<template>
  <div class="analysisreport-channelCrmDetailReport">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <span class="mr10 fs14 color-666">{{
            $t("views.Analysisreport.channelCrmDetailReport.51h4yx8fiqo0")
          }}</span>
          <div class="select-box" style="width: 300px">
            <el-date-picker
              v-model="filter.rang_time"
              type="daterange"
              @change="search"
              :range-separator="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fmf00')
              "
              value-format="yyyy-MM-dd"
              :start-placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fmzw0')
              "
              :end-placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fnis0')
              "
              :picker-options="pickerOptions"
              style="width: 300px"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <!-- <span class="mr10 fs14 color-666">{{
            $t("views.Analysisreport.admTrackReport.51yzwntly2o0")
          }}</span> -->
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="filterCourseCat"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursecat_id"
              clearable
              filterable
              :placeholder="$t('Customersmanage.dac')"
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.courseCatList"
                :key="index"
                :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                :value="item.coursecat_id"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.zhu_marketer_id"
              clearable
              filterable
              collapse-tags
              :placeholder="$t('Analysisreport.bg')"
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.markerList"
                :key="index"
                :label="item.marketer_name"
                :value="item.marketer_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <template v-if="company_isassist == 1">
          <div class="flex-al mb10 mr10">
            <div class="select-box" style="width: 170px">
              <el-select
                v-model="filter.fu_marketer_id"
                clearable
                filterable
                :placeholder="$t('Analysisreport.bh')"
                @change="search"
              >
                <el-option
                  v-for="(item, index) in filterList.markerList"
                  :key="index"
                  :label="item.marketer_name"
                  :value="item.marketer_id"
                ></el-option>
              </el-select>
            </div>
          </div>
        </template>

        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.frommedia_id"
              clearable
              filterable
              collapse-tags
              :placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8foog0')
              "
              @change="frommediaSearch"
            >
              <el-option
                v-for="(item, index) in filterList.sourceList"
                :key="index"
                :label="item.frommedia_name"
                :value="item.frommedia_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 190px">
            <el-select
              v-model="filter.channel_id"
              clearable
              filterable
              multiple
              collapse-tags
              :placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fqd40')
              "
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.channelList"
                :key="index"
                :label="item.channel_name"
                :value="item.channel_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.client_tracestatus"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fra80')
              "
              @change="search"
            >
              <!--0待跟踪1持续跟踪2已邀约3已试听4已转正-1已无意向-2无效名单-->
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8frsw0')
                "
                value="0"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fs700')
                "
                value="1"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fss80')
                "
                value="2"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8ft6c0')
                "
                value="3"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fthw0')
                "
                value="4"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fttw0')
                "
                value="-1"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fu5s0')
                "
                value="-2"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="ipt-box" style="width: 380px">
            <el-input
              v-model="filter.keyword"
              clearable
              :placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fuh00')
              "
              @clear="search"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <el-button
            type="primary"
            size="mini"
            class="search-btn fs14"
            @click="search"
            >{{
              $t("views.Analysisreport.channelCrmDetailReport.51h4yx8fut40")
            }}</el-button
          >
        </div>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
import reportPageTemp from "@/components/report/tableTemplate";
import storeanalysisreport from "../analysisreport.js";
export default {
  name: "analysisreport-channelCrmDetailReport",
  data() {
    return {
      reportParams: {
        wayString: "detailsByChannel", //传递到子组件的方法名称
        Title: this.$t(
          "views.Analysisreport.channelCrmDetailReport.51h4yx8fv9s0"
        ),
      },
      //筛选
      filter: {
        rang_time: "", //选择时间--必须定义为这个参数
        start_time: "",
        end_time: "",
        frommedia_name: '', //渠道类型
        frommedia_id: "", //渠道类型
        channel_id: [], //渠道明细
        client_tracestatus: "", //名单状态
        zhu_marketer_id: "",
        fu_marketer_id: "",
        keyword: "", //关键词
        coursetype_id: "", //班组
        coursecat_id: "",
      },
      // 筛选的下拉列表
      filterList: {
        markerList: [],
        sourceList: [], //选择渠道类型-下拉数据
        channelList: [], //选择渠道明细-下拉数据
        coursetypeList: [], //班组-下拉数据
        courseCatList: [],
      },
      // 时间限制
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },
    };
  },
  components: {
    reportPageTemp,
  },
  updated() {},
  created() {
    this.filter.rang_time = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    this.filter.start_time = this.$Common.getAppointedDate(2, 0).startDate;
    this.filter.end_time = this.$Common.getAppointedDate(2, 0).endDate;
    this.courseTypeRecruitApi();
    this.getTypeCourseCatApi();

    this.getMarketer(); // 渠道类型
    this.getSourceApi(); // 渠道类型
    this.getChannelApi("one"); // 渠道明细
  },
  computed: {
    company_isassist() {
      return this.$store.state.companyIsassist;
    },
  },
  methods: {
    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http
        .courseTypeRecruitApi({
          coursetype_isrecruit: 1,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.filterList.coursetypeList = res.data.data.list;
          } else {
            this.filterList.coursetypeList = [];
          }
        });
    },
    filterCourseCat() {
      this.filter.coursecat_id = "";
      this.getTypeCourseCatApi();
      this.search();
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.filter.coursetype_id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.courseCatList = data.list;
          } else {
            this.filterList.courseCatList = [];
          }
        });
    },
    getMarketer() {
      storeanalysisreport.getMarketer({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.filterList.markerList = data.list;
        } else {
          this.filterList.markerList = [];
        }
      });
    },
    // 渠道类型
    getSourceApi() {
      storeanalysisreport.getSource({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.filterList.sourceList = data.list;
        } else {
          this.filterList.sourceList = [];
        }
      });
    },
    // 渠道明细
    getChannelApi(type) {
      storeanalysisreport
        .getChannel({
          channel_medianame: this.filter.frommedia_name,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.channelList = data.list;
          } else {
            this.filterList.channelList = [];
          }
          if (type == "search") {
            this.$refs.reportPageTemp.search();
          }
        });
    },
    //检索
    search() {
      this.filter.start_time = this.filter.rang_time
        ? this.filter.rang_time[0]
        : "";
      this.filter.end_time = this.filter.rang_time
        ? this.filter.rang_time[1]
        : "";
      this.$refs.reportPageTemp.search();
    },
    // 渠道类型检索
    frommediaSearch() {
      this.filter.channel_id = "";
      this.filterList.sourceList.forEach((e) => {
        if (e.frommedia_id == this.filter.frommedia_id) {
          this.filter.frommedia_name = e.frommedia_name;
        }
      });
      this.getChannelApi("search"); // 渠道明细
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   if (this.$refs["auto_height_table"]) {
    //     this.tableList.options.tableHeight = this.$Tool.getTableHeight(
    //       this.$refs.auto_height_table.getBoundingClientRect().top + 75
    //     );
    //   }
    // });
  },
};
</script>
<style lang="less">
.analysisreport-channelCrmDetailReport {
  .el-main {
    margin-bottom: 0px;
  }
}
</style>
